function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M30.8391 10.465C31.6357 10.5447 32.1535 10.9629 32.3925 11.7197C32.6314 12.4765 32.4721 13.1337 31.9145 13.6913L25.5814 19.8452L27.0751 28.5681C27.1945 29.3249 26.9356 29.9224 26.2984 30.3605C25.6611 30.8385 25.0039 30.8982 24.3267 30.5397L16.5 26.477L8.67326 30.5397C7.99614 30.938 7.33894 30.8982 6.70164 30.4202C6.06435 29.9423 5.80545 29.3249 5.92494 28.5681L7.4186 19.8452L1.08551 13.6913C0.527882 13.1337 0.368559 12.4765 0.607543 11.7197C0.846527 10.9629 1.36433 10.5447 2.16094 10.465L10.8839 9.15063L14.7674 1.26415C15.1258 0.547197 15.7034 0.188721 16.5 0.188721C17.2966 0.188721 17.8742 0.547197 18.2326 1.26415L22.1161 9.15063L30.8391 10.465ZM23.55 19.188L30.6001 12.3172L20.8615 10.943L16.5 2.1006L12.1385 10.943L2.39993 12.3172L9.44996 19.188L7.77707 28.8668L16.5 24.3261L25.2229 28.8668L23.55 19.188Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6ac5826e44169450de25ddc4f39ce3ff.svg";
export { ForwardRef as ReactComponent };